import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApiService, UserInfo } from 'app/services/api.service';

@Component({
  selector: 'app-table-rewards',
  templateUrl: './table-rewards.component.html',
  styleUrl: './table-rewards.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})


export class TableRewardsComponent implements OnInit{

  userInfo: UserInfo;

  classCategories = {
    title: 'title-column',
    pro: 'pro-column',
    elite: 'elite-column',
    premium: 'premium-column',
    roboto: 'roboto'
  };

  mobileClassCategories = {
    able: 'account-benefit',
    disabled: 'account-benefit disabled'
  };

  tableSelectedColumn = [
    { class: this.classCategories.title, label: '' },
    { class: this.classCategories.pro, label: this.translateService.instant('benefits_we.esta_es_tu') },
    { class: this.classCategories.elite, label: this.translateService.instant('benefits_we.esta_es_tu') },
    { class: this.classCategories.premium, label: this.translateService.instant('benefits_we.esta_es_tu') }
  ].map((el, idx) => ({ key: idx, ...el }));

  tableColumns = [
    { class: this.classCategories.title, label: '' },
    { class: this.classCategories.pro, label: this.translateService.instant('benefits_we.pro') },
    { class: this.classCategories.elite, label: this.translateService.instant('benefits_we.elite_p') },
    { class: this.classCategories.premium, label: this.translateService.instant('benefits_we.premium') }
  ].map((el, idx) => ({ key: idx, ...el }));

  tableRows : TableRow[] = []; // Se llenará en ngOnInit
  tableRowsMobile : MobileRow[] = [];
  userMobileRow: MobileRow | null = null;

  constructor(private api: ApiService, private translateService: TranslateService ) {}

  ngOnInit() {
    this.api.userInfo.subscribe(ui => {
      this.userInfo = ui; // pro=advanced | elite | premium | platinum
      //this.userInfo.loyaltyLevel = 'premium';
      const baseRows = this.getBaseRows();

      this.tableRows = baseRows.map((el, idx) => ({
        key: idx,
        rows: el.map((row, id) => {
          const { key, ...rest } = row;
          return { ...rest, key: id };
        })
      }));

      // Solo una fila mobile: la del loyalty del usuario
      let status = this.userInfo?.loyaltyLevel?.toLowerCase(); // 'pro', 'elite', 'premium'
      if (status === 'advanced') {
        status = 'pro'; // Mapeamos 'advanced' a 'pro'
      }
      const mobileRows = this.getMobileRows(baseRows);
      const foundRow = mobileRows.find(row => row.classContainer.includes(status?status:'elite'));
      this.userMobileRow = foundRow ? { ...foundRow, key: 0 } : null;
    });
  }

  getBaseRows(): TableCell[][] {
    const rows = [
      [this.translateService.instant('rewards.Accede_a_eCosentino'), true, true, true],
      [this.translateService.instant('rewards.WeRewardsTableProfessionalPlatform'), true, true, true],
      [this.translateService.instant('benefits_we.benefits_clientes_potenciales'), false, true, true],
      [this.translateService.instant('rewards.WeRewardsTableFinancialPortal'), true, true, true],
      [this.translateService.instant('rewards.WeRewardsTableQuotingAndRates'), true, true, true],
      [this.translateService.instant('rewards.WeRewardsTableCaseLogging'), true, true, true],
      [this.translateService.instant('benefits_we.benefits_mas_visibilidad'), true, true, true],
      [this.translateService.instant('order_samples.solicita_muestra'),
          this.translateService.instant('rewards.Standard_Shipping'),
          this.translateService.instant('rewards.Free_Shipping'),
          this.translateService.instant('rewards.Free_Shipping')],
      [this.translateService.instant('rewards.WeRewardsTableDisplayPolicy'),
          this.translateService.instant('rewards.Selection_of_colors'),
          this.translateService.instant('rewards.all_colors'),
          this.translateService.instant('rewards.all_colors')],
      [this.translateService.instant('benefits_we.benefits_herramientas_marketing'), true,
          this.translateService.instant('rewards.Priority'),
          this.translateService.instant('rewards.Top_Priority2')],
      [this.translateService.instant('rewards.WeRewardsWePromote'), false, true, true],
      [this.translateService.instant('rewards.WeRewardsTableFindYourBusiness'), false, true,
          this.translateService.instant('benefits_we.benefits_posicionamiento')],
      [this.translateService.instant('rewards.WeRewardsCoursesAndEvents'), true, true, true]
    ];


    return rows.map((row, idx) => {
      const [label, pro, elite, premium] = row;
      return [
        {
          key: 0,
          classTd: this.classCategories.title,
          classSpan: 'roboto',
          label: String(label),
          labelMobile: String(label)
        },
        {
          key: 1,
          classTd: this.classCategories.pro,
          classSpan: typeof pro === 'string' ? '' : 'dot',
          label: typeof pro === 'string' ? pro : '',
          labelMobile: String(label),
          classMobile: typeof pro === 'boolean' && !pro ? this.mobileClassCategories.disabled : this.mobileClassCategories.able,
          statusMobile: 'pro'
        },
        {
          key: 2,
          classTd: this.classCategories.elite,
          classSpan: typeof elite === 'string' ? '' : 'dot',
          label: typeof elite === 'string' ? elite : '',
          labelMobile: String(label),
          classMobile: typeof elite === 'boolean' && !elite ? this.mobileClassCategories.disabled : this.mobileClassCategories.able,
          statusMobile: 'elite'
        },
        {
          key: 3,
          classTd: this.classCategories.premium,
          classSpan: typeof premium === 'string' ? '' : 'dot',
          label: typeof premium === 'string' ? premium : '',
          labelMobile: String(label),
          classMobile: typeof premium === 'boolean' && !premium ? this.mobileClassCategories.disabled : this.mobileClassCategories.able,
          statusMobile: 'premium'
        }
      ];
    });

  }


getMobileRows(baseRows: TableCell[][]): { classContainer: string; rows: TableCell[] }[] {
  const extractMobileRows = (status: string, classContainer: string) => {
    const rows = baseRows.map((row, idx) => {
      const [title, ...rest] = row;
      const match = rest.find(cell => cell.statusMobile === status);
      return {
        key: idx,
        classTd: match?.classTd || '',
        classSpan: title.classSpan,
        label: match?.label || '',
        labelMobile: title.label,
        classMobile: match?.classMobile || '',
        statusMobile: status
      } as TableCell;
    });

    const header: TableCell[] = [
      {
        key: -2,
        classTd: '',
        classSpan: '',
        label: this.translateService.instant('benefits_we.esta_es_tu'),
        labelMobile: 'asddd',
        classMobile: 'user-category',
        statusMobile: status,
        userCategory: true
      },
      {
        key: -1,
        classTd: '',
        classSpan: '',
        label: this.translateService.instant(`benefits_we.${status}_p`),
        labelMobile: this.translateService.instant(`benefits_we.${status}_p`),
        classMobile: 'account-tupe-title',
        statusMobile: status
      }
    ];

    return {
      classContainer,
      rows: [...header, ...rows]
    };
  };

  return [
    extractMobileRows('pro', 'benefits-pro'),
    extractMobileRows('elite', 'benefits-elite'),
    extractMobileRows('premium', 'benefits-premium')
  ];
}

  getTranslatedLabel(key: string): string {
    return this.translateService.instant(key);
  }

}

interface TableCell {
  key: number;
  classTd: string;
  classSpan: string;
  label: string;
  labelMobile: string;
  classMobile?: string;
  statusMobile?: string;
  userCategory?: boolean;
}

interface TableRow {
  key: number;
  rows: TableCell[];
}

interface MobileRow {
  key: number;
  classContainer: string;
  rows: TableCell[];
}


